import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../api.service';
import { UserLayout } from './models';

@Injectable({ providedIn: 'root' })
export class UserLayoutApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiService = inject(ApiService);

  fetchLayout(userId: string): Observable<UserLayout> {
    this.apiService.setHeaders();

    return this.httpClient.get<UserLayout>(
      `${environment.zuul}v1/user/getLayoutSettings?userId=${userId}`,
      this.apiService.getHttpOptions(),
    );
  }

  saveUserLayout(
    layout: UserLayout | null,
    userId: string,
  ): Observable<unknown> {
    this.apiService.setHeaders();

    return this.httpClient.post<UserLayout>(
      `${environment.zuul}v1/user/saveLayoutSettings?userId=${userId}`,
      layout,
      this.apiService.getHttpOptions(),
    );
  }
}
